import { View } from "react-native";
import { Switch } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

import InfoText from "./InfoText";

type Props = {
  enabled: boolean;
  onChange: (value: boolean) => void;
};
export default function DeliveryModeEnabledSwitch({
  enabled,
  onChange,
}: Props) {
  const tailwind = useTailwind();

  const title = `${enabled ? "Desactivar" : "Activar"} envíos automáticos`;

  const details = `Pulsa para ${
    enabled ? "desactivar" : "activar"
  } el servicio de envíos coordinado por Cuanto.`;

  return (
    <View style={tailwind("flex-row")}>
      <InfoText title={title} details={details} style={tailwind("flex-1")} />

      <Switch
        value={enabled}
        onValueChange={onChange}
        style={tailwind("self-center")}
      />
    </View>
  );
}
